import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Platform } from 'ionic-angular';

declare const lottie: any;

@Component({
  selector: 'page-hero',
  templateUrl: 'page-hero.html'
})
export class PageHeroComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() lottiePath: string = '';
  @Input() accentIcon: string = '';
  @Input() accentColor: string = 'primary';
  /** When true, Lottie fills the hero card width (taller stage) for layout tests */
  @Input() lottieWide: boolean = false;
  /** Optional “rate us on the store” CTA (home and similar screens) */
  @Input() showRateStoreCta: boolean = false;
  @Input() storeRateLabel: string = 'App Store';
  @Output() rateStoreClick = new EventEmitter<void>();

  @ViewChild('lottieStage') lottieStage: ElementRef;

  constructor(private platform: Platform) { }

  get showRateStoreCtaVisible(): boolean {
    return this.showRateStoreCta
      && this.platform.is('ios') || this.platform.is('android');
  }

  onRateStoreClick() {
    this.rateStoreClick.emit();
  }
  private anim: any;

  ngAfterViewInit() {
    if (this.lottiePath) {
      this.initLottie();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['lottiePath'] && !changes['lottiePath'].firstChange) {
      this.destroyLottie();
      if (this.lottiePath) {
        setTimeout(() => this.initLottie(), 0);
      }
    }
  }

  ngOnDestroy() {
    this.destroyLottie();
  }

  ionViewDidEnter() {
    if (this.lottiePath && !this.anim) {
      this.initLottie();
    }
  }

  private initLottie(retryCount: number = 0) {
    const container = this.lottieStage && this.lottieStage.nativeElement;
    if (!container) {
      if (retryCount < 10) {
        setTimeout(() => this.initLottie(retryCount + 1), 200);
      }
      return;
    }

    if (typeof lottie === 'undefined') {
      if (retryCount < 20) {
        setTimeout(() => this.initLottie(retryCount + 1), 200);
      } else {
        console.log('page-hero: lottie global not available after retries');
      }
      return;
    }

    if (this.anim) {
      return;
    }

    try {
      this.anim = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: this.lottiePath,
      });
      this.anim.addEventListener('data_failed', (err: any) => {
        console.log('page-hero: lottie data_failed for', this.lottiePath, err);
      });
    } catch (e) {
      console.log('page-hero: lottie init error', e);
    }
  }

  private destroyLottie() {
    if (this.anim) {
      try { this.anim.destroy(); } catch (e) { /* noop */ }
      this.anim = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/page-hero/page-hero.ts